import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import { IHelpSection } from '../models';
import HelpTags from '../HelpTags';

import messages from './messages';

interface IProps {
  sections?: IHelpSection[];
}

const HelpTableOfContents = ({ sections = [] }: IProps) => {
  return sections.length > 0 ? (
    <Box>
      <Typography variant='h5'>
        <FormattedMessage {...messages.tableOfContents} />
      </Typography>
      <ul>
        {sections.map((section) => (
          <li key={section.hash}>
            <Box display='flex'>
              <Link component={RouterLink} to={`#${section.hash}`}>
                {section.label}
              </Link>
              <HelpTags section={section} />
            </Box>
          </li>
        ))}
      </ul>
    </Box>
  ) : null;
};

export default HelpTableOfContents;
